import { Container } from './styled';
import PropTypes from 'prop-types';
import { configurationActions } from 'core/Configuration';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    ExpandButton,
    Input,
    Text
} from 'mol-ui';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const SpecificDay = ({
    clearDate,
    specificDate
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        absenceRate: { special_days = [] },
        absenceRateProcessing: processing
    } = useSelector('configuration');
    const [workingHours, setWorkingHours] = useState(null);

    useEffect(() => {
        if (!isEmpty(special_days)) {
            const date = special_days.find(({ date }) => moment(date).isSame(specificDate, 'day'));
            setWorkingHours(date?.hours ?? '');
        }
    }, [specificDate]);
    
    const onSave = () => {
        const payload = {
            day: moment(specificDate).format('YYYY-MM-DD'),
            hours: workingHours !== '' ? Number(workingHours) : null
        };
        dispatch(configurationActions.upsertSpecialDay(payload));
        clearDate(null);
    };

    const title = `${ t('Fecha') }: ${ moment(specificDate).format('DD/MM/YYYY') }`;

    if (!specificDate) return null;
    
    return (
        <Container>
            <Text
                margin="20px 0px"
                textAlign="center"
            >
                { title }
            </Text>
            <Input
                fixedWidth
                flex="1"
                placeholder={ t('Horas') }
                type="number"
                value={ workingHours !== null ? workingHours.toString() : '' }
                onChange={ value => setWorkingHours(value) }
            />
            <ButtonFooter>
                <ExpandButton
                    caption={ t('Guardar') }
                    loading={ processing }
                    size={ 100 }
                    onClick={ onSave }
                />
            </ButtonFooter>
        </Container>
    );
};

SpecificDay.propTypes = {
    clearDate: PropTypes.func,
    specificDate: PropTypes.object
};

export default SpecificDay;
